module.exports = "/images/logo-globalguardian.svg?469758faad50c637274cd54eb5c23ef3";